import { FormControl } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useStates } from "@/api/data"
import { State } from "@/api/data"

interface StateSelectProps {
  onChange: (value: string) => void;
  defaultValue: string;
  value: string | undefined;
  countryId: string;
}

export default function StateSelect({
  onChange,
  value,
  defaultValue,
  countryId,
}: StateSelectProps) {
  const { states, isLoading } = useStates(countryId)

  return (
    <Select
      value={value}
      onValueChange={onChange}
      defaultValue={defaultValue}
      disabled={isLoading || states.length === 0}
    >
      <FormControl>
        <SelectTrigger>
          <SelectValue
            placeholder={isLoading ? "Loading states..." : "Select state"}
          />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {states.map((state: State) => (
          <SelectItem key={state.id} value={state.id.toString()}>
            {state.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
